/**
 * Size options for BrandLogo component
 * Controls the dimensions of the logo container, icon, and text
 */
export enum BrandLogoSize {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}
